import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router'
import { Message } from '../models/message'
import { MessagingService } from '../services/messaging.service'
import { AuthStore } from '../stores/auth.store'
import { createTreeFromURL } from '../utilities/urls'

@Injectable()
export class Unauthorised {
  private router = inject(Router)
  private authStore = inject(AuthStore)
  private messaging = inject(MessagingService)

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const subscription = this.messaging.intercept((message: Message) => {
      if (message.visible) {
        if (message.id === 'http-forbidden') {
          message.visible = false
        }
      }
    })
    const user = await this.authStore.waitForUser()

    subscription.unsubscribe()
    if (!user) {
      return true
    }
    if (route.queryParams['return_url']) {
      return this.router.createUrlTree(
        ...createTreeFromURL(route.queryParams['return_url'])
      )
    }
    return this.router.createUrlTree(['/'])
  }
}
